module.exports = __webpack_public_path__ + "img/letter.3985cc5d.svg";